import React from "react";
import PasswordResetForm from "../components/password-reset/PasswordResetForm";

export default function PasswordReset() {
  return <PasswordResetForm />;
}
